module.exports = __webpack_public_path__ + "media/images/procedure_managements/examples/tasks_mobile_image-35a4f2b6cfe8f10f4c4012e22ee990c2.jpg";